export enum PrivateRegionNodeType {
  AllNode = 0,
  ComputeNode = 1,
  StorageNode = 2,
}

export enum PrivateRegionNodeStatus {
  NodeOffline = 0,
  NodeOnline = 1,
}

// Private region domain ID
export const PRIVATE_REGION_DOMAIN = 1001

// Private region datadrive currently only supports read-only access
export function isPrivateRegionDomain(domain: number): boolean {
  return domain === PRIVATE_REGION_DOMAIN
}

export function hasPrivateRegionDomain(domains: number[] | undefined): boolean {
  return domains?.some(isPrivateRegionDomain) ?? false
}
